import theme from "@/styles/novaTheme";
import { css } from "@emotion/react";

export const styleTextNova = {
  title: css({
    color: theme.colors.blue400,
    fontFamily: theme.fonts.ProximaNovaLight,
    fontSize: theme.vars.h1FontSizeMin,
    strong: {
      fontFamily: theme.fonts.ProximaNovaSbold
    },
    a: {
      color: theme.colors.blue400,
      textDecoration: "underline"
    }
  }),
  title3: css({
    color: theme.colors.blueGray900,
    fontFamily: theme.fonts.ProximaNovaSbold,
    fontSize: theme.vars.h2FontSizeMin,
    margin: 0
  }),
  subtitle3: css({
    color: theme.colors.blueGray800,
    fontFamily: theme.fonts.ProximaNovaSbold,
    lineHeight: "1em",
    fontSize: theme.vars.h3FontSizeMin,
    margin: 0,
    em: {
      fontFamily: theme.fonts.ProximaNovaSbold
    }
  }),
  text: css({
    color: theme.colors.blueGray800,
    fontFamily: theme.fonts.ProximaNovaLight,
    fontSize: theme.vars.pFontSizeMin,
    lineHeight: "1em",
    margin: 0
  }),
  label: css({
    color: theme.colors.blue400,
    fontFamily: theme.fonts.ProximaNovaLight,
    fontSize: theme.vars.pFontSizeMin,
    strong: {
      fontFamily: theme.fonts.ProximaNovaSbold
    }
  }),
  copyright: css({
    color: theme.colors.blueGray800,
    fontFamily: theme.fonts.ProximaNovaLight,
    fontSize: theme.vars.boxInfoFontSizeMin,
    lineHeight: "1em",
    margin: 0
  })
};
